import { VFC } from 'react';

const TermsOfService: VFC = () => {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-8 text-center">利用規約</h1>
      
      <div className="space-y-6">
        <p className="mb-8">
          この利用規約（以下、「本規約」といいます。）は、パンダッコ（以下、「当社」といいます。）がこのウェブサイト上で提供するオンライン予約（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従って、本サービスをご利用いただきます。
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第1条（適用）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</li>
            <li>当社は本サービスに関し，本規約のほか，ご利用にあたってのルール等，各種の定め（以下,「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず，本規約の一部を構成するものとします。</li>
            <li>本規約の定めが前項の個別規定の定めと矛盾する場合には，個別規定において特段の定めなき限り，個別規定の定めが優先されるものとします。</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第2条（利用登録）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>本サービスにおいては，登録希望者が本規約に同意の上，当社の定める方法によって利用登録を申請し，当社がこれに対する承認を登録希望者に通知することによって，利用登録が完了するものとします。</li>
            <li>当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。
              <ol className="list-decimal list-inside ml-6 mt-2 space-y-1">
                <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
                <li>本規約に違反したことがある者からの申請である場合</li>
                <li>その他，当社が利用登録を相当でないと判断した場合</li>
              </ol>
            </li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第3条（ユーザーIDおよびパスワードの管理）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>ユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを管理するものとします。</li>
            <li>ユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡または貸与し，もしくは第三者と共用することはできません。当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。</li>
            <li>ユーザーID及びパスワードが第三者に使用されたことによって生じた損害は，当社に故意又は重大な過失がある場合を除き，当社は一切の責任を負わないものとします。</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第4条（予約の成立）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>本サービスにおいては、ユーザーが当社に対して予約の申し込みを完了し、アプリ内の履歴ページに予約内容が表示された時点で予約が成立したものとします。</li>
            <li>当社は，ユーザーが以下のいずれかの事由に該当する場合には，ユーザーに通知することにより、成立した予約を取り消すことができるものとします。
              <ol className="list-decimal list-inside ml-6 mt-2 space-y-1">
                <li>ユーザーが本規約に違反した場合</li>
                <li>システム障害や人為的ミスにより、誤った予約内容が表示された場合</li>
                <li>その他当社が予約の維持を適当でないと判断した場合</li>
              </ol>
            </li>
            <li>本サービスに関する予約方法、キャンセル方法、支払方法等については、別途当社が定める方法によります。</li>
            <li>予約した商品の受け取りおよび支払いは、当社の店舗にて行うものとします。</li>
            <li>当社は、一回の予約あたりの商品数や金額、あるいは一定期間内の予約回数に上限を設ける場合があります。これらの制限は、本サービス内で別途告知します。</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第5条（予約のキャンセル）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>ユーザーは、予約をキャンセルする場合、当社が定める方法で速やかに連絡するものとします。</li>
            <li>予約のキャンセルは、商品の製造開始前に限り可能とします。製造開始後のキャンセルはできません。</li>
            <li>度重なる無断キャンセルや予約商品の未受取りがある場合、当社は当該ユーザーの予約を制限することがあります。</li>
            <li>当社は、天災地変、停電、システム障害、その他の不可抗力により商品の製造や提供ができない場合、予約をキャンセルすることがあります。この場合、当社は速やかにユーザーに通知するものとします。</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第6条（知的財産権）</h2>
          <p className="leading-relaxed">
            本サービスによって提供される商品写真その他のコンテンツ（以下「コンテンツ」といいます）の著作権又はその他の知的所有権は,当社及びコンテンツ提供者などの正当な権利者に帰属し,ユーザーは,これらを無断で複製,転載,改変,その他の二次利用をすることはできません。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第7条（禁止事項）</h2>
          <p className="mb-4">ユーザーは，本サービスの利用にあたり，以下の行為をしてはならないものとします。</p>
          <ol className="list-decimal list-inside space-y-2">
            <li>法令または公序良俗に違反する行為</li>
            <li>犯罪行為に関連する行為</li>
            <li>本サービスに含まれる著作権，商標権その他の知的財産権を侵害する行為</li>
            <li>当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為</li>
            <li>本サービスによって得られた情報を商業的に利用する行為</li>
            <li>当社のサービスの運営を妨害するおそれのある行為</li>
            <li>不正アクセスをし，またはこれを試みる行為</li>
            <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
            <li>他のユーザーに成りすます行為</li>
            <li>当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為</li>
            <li>その他，当社が不適切と判断する行為</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第8条（本サービスの提供の停止等）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
              <ol className="list-decimal list-inside ml-6 mt-2 space-y-1">
                <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
                <li>地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合</li>
                <li>コンピュータまたは通信回線等が事故により停止した場合</li>
                <li>その他，当社が本サービスの提供が困難と判断した場合</li>
              </ol>
            </li>
            <li>当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害について，理由を問わず一切の責任を負わないものとします。</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第9条（利用制限および登録抹消）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>当社は，以下のいずれかに該当する場合には，事前の通知なく，ユーザーに対して，本サービスの全部もしくは一部の利用を制限し，またはユーザーとしての登録を抹消することができるものとします。
              <ol className="list-decimal list-inside ml-6 mt-2 space-y-1">
                <li>本規約のいずれかの条項に違反した場合</li>
                <li>登録事項に虚偽の事実があることが判明した場合</li>
                <li>料金等の支払債務の不履行があった場合</li>
                <li>当社からの連絡に対し，一定期間返答がない場合</li>
                <li>本サービスについて，最終の利用から一定期間利用がない場合</li>
                <li>その他，当社が本サービスの利用を適当でないと判断した場合</li>
              </ol>
            </li>
            <li>当社は，本条に基づき当社が行った行為によりユーザーに生じた損害について，一切の責任を負いません。</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第10条（退会）</h2>
          <p className="leading-relaxed">
            ユーザーは，所定の退会手続により，本サービスから退会できるものとします。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第11条（保証の否認および免責事項）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>当社は,本サービスに事実上または法律上の瑕疵（安全性,信頼性,正確性,完全性,有効性,特定の目的への適合性,セキュリティなどに関する欠陥,エラーやバグ,権利侵害などを含みます。）がないことを保証するものではありません。</li>
            <li>当社は,本サービスによってユーザーに生じたあらゆる損害について,一切の責任を負いません。ただし,本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合,この免責規定は適用されませんが,この場合であっても,当社は,当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し,または予見し得た場合を含みます。）について一切の責任を負いません。</li>
            <li>当社は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。</li>
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第12条（サービス内容の変更等）</h2>
          <p className="leading-relaxed">
            当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第13条（利用規約の変更）</h2>
          <p className="leading-relaxed">
            当社は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお，本規約の変更後，本サービスの利用を開始した場合には，当該ユーザーは変更後の規約に同意したものとみなします。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第14条（個人情報の取扱い）</h2>
          <p className="leading-relaxed">
            当社は，本サービスの利用によって取得する個人情報については，当社「プライバシーポリシー」に従い適切に取り扱うものとします。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第15条（通知または連絡）</h2>
          <p className="leading-relaxed">
            ユーザーと当社との間の通知または連絡は，当社の定める方法によって行うものとします。当社は,ユーザーから,当社が別途定める方式に従った変更届け出がない限り,現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い,これらは,発信時にユーザーへ到達したものとみなします。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第16条（権利義務の譲渡の禁止）</h2>
          <p className="leading-relaxed">
            ユーザーは，当社の書面による事前の承諾なく，利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し，または担保に供することはできません。
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">第17条（準拠法・裁判管轄）</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>本規約の解釈にあたっては，日本法を準拠法とします。なお，本サービスに関しては，国際物品売買契約に関する国際連合条約の適用を排除するものとします。</li>
            <li>本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。</li>
          </ol>
        </section>

        <p className="text-right mt-12">以上</p>
      </div>
    </div>
  );
};

export default TermsOfService;